import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Button } from '@ds/react-components';
import { Link } from 'react-router-dom';

const styles = (theme) => ({
  root: {
    textAlign: 'center',
    position: 'fixed',
    top: '50%',
    left: '50%',
    marginLeft: '-200px',
    marginTop: '-85px',
    '& span': {
      display: 'block',
    },
    '& span.header': {
      fontSize: '32px',
      fontWeight: '700',
      lineHeight: '38.4px',
      paddingBottom: '12px',
    },
    '& span.body': {
      fontSize: '20px',
      fontWeight: '400',
      lineHeight: '30px',
      color: '#666666',
    },
    '& span.footer': {
      paddingTop: '24px',
    },
  },
});

class Oops extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <span className="{classes.root} header">Oops...</span>
        <span className="{classes.root} body">
          Sorry, your session has timed out
        </span>
        <span className="{classes.root} body">
          or you don&apos;t have permission to view this page.
        </span>
        <span className="{classes.root} footer">
          <Button
            text="Take me back"
            variant="outlined"
            component={Link}
            to={'/Accounts'}
          />
        </span>
      </div>
    );
  }
}

Oops.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Oops);
